import { FC } from "react";
import { Box, Text, Flex } from "@smile2impress/components/relaunch";

import { MainBannerAdvantagesProps } from "./MainBannerAdvantages.types";

export const MainBannerAdvantages: FC<MainBannerAdvantagesProps> = ({
    advantages,
}) => {
    return (
        <Flex direction="column">
            {advantages.map((adv, i) => (
                <Box mb={[1]} _last={{ mb: 0 }} key={i}>
                    <Text
                        textStyle={["body"]}
                        color="text.baseInverse"
                        mb={[0, 0, 0.5]}
                    >
                        {adv.title}
                    </Text>
                    <Text textStyle={["H2"]} color="text.baseInverse">
                        {adv.subtitle}
                    </Text>
                </Box>
            ))}
        </Flex>
    );
};
